import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { Link } from 'react-router'

import { useVerifyEmailMutation } from '../../services/apiSlice'
import Spinner from '../../components/loading/Spinner'

const EmailVerification: React.FC = () => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const [verifyEmail, { data, isLoading, isError, error }] =
    useVerifyEmailMutation()

  const email = searchParams.get('email')
  const token = searchParams.get('token')

  let display = <Spinner />

  if (!email || !token) {
    display = <h1>Invalid verification data.</h1>
  }

  useEffect(() => {
    if (email && token) {
      verifyEmail({ email, token })
    }
  }, [email, token, verifyEmail])

  console.log(error)

  if (isLoading) {
    display = <Spinner />
  }
  if (isError) {
    display = (
      <h1 className="text-red-500">
        Something went wrong, please try again later.
      </h1>
    )
  }
  if (data) {
    display = (
      <div className="flex h-full w-full flex-col items-center justify-center">
        <h1>Email Verified!</h1>
        <Link
          to="/"
          className="hover-main border-theme text-sub mt-[20px] rounded-full border px-[20px] py-[10px] text-sm"
        >
          Return to login page
        </Link>
      </div>
    )
  }

  return (
    <div className="flex h-dvh w-dvw items-center justify-center text-2xl text-green-500">
      {display}
    </div>
  )
}

export default EmailVerification
